export default "__VITE_ASSET__OdwmvdQ1__"